import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaintBucket: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPaintBucket"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C15.7277 2 18.86 4.54954 19.748 8H21V10H20V22H4V10H3V8H4.25195C5.14003 4.54954 8.27231 2 12 2ZM12 4C9.38772 4 7.16657 5.66984 6.34277 8H8V14H10V8H11V12H13V8H17.6572C16.8334 5.66984 14.6123 4 12 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPaintBucket;
